module.exports = __webpack_public_path__ + "6bb9262007595f53eb01fce8d96e22a8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-30.png
// module id = 1748
// module chunks = 0